<template>
  <div class="w-full grid gap-1 content-start">
    <label v-if="labelText">{{ labelText }}</label>

    <v-textarea
      class="focus-within:!border-primary-main border-2 focus-within:outline outline-2 duration-200 bg-white p-3 pt-0 outline-primary-main/20 rounded-lg tl-input"
      :class="classObject"
      :no-resize="noResize"
      variant="plain"
      :value="modelValue" 
      @input="$emit('update:modelValue', $event.target.value)"
      placeholder="Type here..."
      :maxlength="maxlength || 524288"
      :hide-details="true"
      :rows="rows"
      :disabled="disabled"
    >
    </v-textarea>
  </div>
</template>

<script lang="ts">
import type Vue from 'vue';
import { VTextarea } from 'vuetify/components';

export default {
  extends: VTextarea,
  props: {
    modelValue: String,
    customClass: String,
    maxlength: { type: Number, required: false },
    labelText: { type: String, required: false },
    rows: { type: Number, required: false },
    disabled: { type: Boolean, required: false, default: false },
    noResize: { type: Boolean, required: false, default: false }
  }
} as Vue.ComponentOptions<any>;
</script>
